exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red[data-v-68037856]{color:red}.input-section[data-v-68037856]{margin-top:10px}", ""]);

// exports
